export type LoginError = {
    errorType: "LOGIN_ERROR",

    // readable error identifier, e.g. "invalid authorization username/password"
    errorMessage: string,

    // technical error code
    errorCode: "NO_LICENCE" | "ONLY_CODEMETER_ALLOWED" | "INVALID_LESSON_CODE" | "INVALID_CREDENTIALS" | "NOT_ALLOWED",
}

export const isLoginError = (error: any): error is LoginError =>
    'errorType' in error
    && 'errorMessage' in error
    && 'errorCode' in error;
